module.exports = __webpack_public_path__ + "media/images/badge/campionato-finalista-cf965b1a53e9a2f10f2b4c422428bfc7.png";